import {
  Camera,
  FileSpreadsheet,
  FileText,
  Image,
  Mail,
  Map,
  PenLine,
  Receipt,
  ScrollText,
  ShoppingCart,
} from "lucide-react";
import {
  getFileExtension,
  isEmailPreviewFile,
  isImageFile,
  isPdfFile,
} from "./filePreview.js";

const ICON_BY_KEY = {
  camera: Camera,
  image: Image,
  map: Map,
  pen: PenLine,
  mail: Mail,
  receipt: Receipt,
  cart: ShoppingCart,
  scroll: ScrollText,
  spreadsheet: FileSpreadsheet,
  file: FileText,
};

const ICON_KEY_BY_ENTITY_TYP = {
  foto: "camera",
  plan: "map",
  skizze: "pen",
  "e-mail": "mail",
  email: "mail",
  offerte: "file",
  rechnung: "receipt",
  bestellung: "cart",
  protokoll: "scroll",
  rapport: "scroll",
  sonstiges: "file",
};

function normalizeEntityTyp(typ) {
  return String(typ || "")
    .trim()
    .toLowerCase()
    .replace(/\s+/g, " ");
}

/** Testbarer Schlüssel für das passende Lucide-Icon. */
export function getEntityInlineFileIconKey(row) {
  const typKey = normalizeEntityTyp(row?.typ);
  if (typKey && ICON_KEY_BY_ENTITY_TYP[typKey]) {
    return ICON_KEY_BY_ENTITY_TYP[typKey];
  }

  const ext = getFileExtension(row?.originalname || row?.dateipfad || "");
  if (isImageFile(ext)) return "image";
  if (isPdfFile(ext)) return "file";
  if (isEmailPreviewFile(ext)) return "mail";
  if (["xls", "xlsx", "csv"].includes(ext)) return "spreadsheet";

  return "file";
}

export function resolveEntityInlineFileIcon(row) {
  const key = getEntityInlineFileIconKey(row);
  return ICON_BY_KEY[key] || FileText;
}
